import { render } from "./TeamStats.vue?vue&type=template&id=54cb3c90"
import script from "./TeamStats.vue?vue&type=script&lang=js"
export * from "./TeamStats.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__